<table mat-table [dataSource]="[metadata]" *ngIf="!isCommon && (metadata.name!=='columnList' && metadata.name!=='rowList') && metadata.isDisplay && !metadata.isFieldType('TableColumn')">
  <ng-container matColumnDef="propertyValue">
    <td class="metadata-item" mat-cell *matCellDef="let metadata">
      <ng-container *ngIf="metadata.isFieldType('ReadOnly')">
        <mat-label>{{'objects.' + getPropertyName(metadata) | translate}}{{ metadata.isEdited ? '＊' : '' }} </mat-label>
        {{'objects.' + metadata.value | translate}}
      </ng-container>
      <mat-form-field class="property-form-field" *ngIf="metadata.isFieldType('Text')">
        <mat-label>{{'objects.' + getPropertyName(metadata) | translate}}{{ metadata.isEdited ? '＊' : '' }} </mat-label>
        <input matInput type="text" [formControl]="textField" [value]="metadata.value" (change)="onChangeAtText()"
          [attr.maxlength]="metadata.name === 'value' ? (maxLengthValue ? maxLengthValue : 0) :null">
        <mat-error align="start" *ngIf="isRequiredError() || textField.hasError('required')">
          <font>{{'objects.errormessage_' + errorMessage.REQUIRED | translate}}</font>
        </mat-error>
        <mat-error align="start" *ngIf="isIllegalError()">
          <font>{{'objects.errormessage_' + errorMessage.LOWERCASE| translate}}</font>
        </mat-error>
      </mat-form-field>
      <mat-form-field class="property-form-field" *ngIf="metadata.isFieldType('Number')">
        <mat-label>{{'objects.' + getPropertyName(metadata) | translate}}{{ metadata.isEdited ? '＊' : '' }} </mat-label>
        <input matInput [formControl]="numberField" type="number" [value]="metadata.value" (change)="onChangeAtNumber()">
        <mat-error align="start" *ngIf="numberField.hasError('required')">
          <font>{{'objects.errormessage_' + errorMessage.REQUIRED| translate}}</font>
        </mat-error>
        <mat-error align="start" *ngIf="numberField.hasError('pattern') && !numberField.hasError('required')">
          <font>{{'objects.errormessage_' + errorMessage.PATTERN| translate}}</font>
        </mat-error>
      </mat-form-field>
      <mat-form-field class="property-form-field" *ngIf="metadata.isFieldType('Color')">
        <mat-label>{{'objects.' + getPropertyName(metadata) | translate}}{{ metadata.isEdited ? '＊' : '' }} </mat-label>
        <div class="d-flex" [(colorPicker)]="color" [cpPosition]="'top-left'" [cpUseRootViewContainer]="true" [cpWidth]="'190px'" [cpPositionOffset]="'-75%'"
          (colorPickerChange)="onChangeAtColor($event)">
          <div *ngIf="metadata.value !== null" class="color-box" [style.background]="color || metadata.value"></div>
          <input matInput [formControl]="colorField" [value]="color || metadata.value" />
        </div>
      </mat-form-field>
      <!--<div class="d-flex" *ngIf="metadata.isFieldType('Color')" [(colorPicker)]="color" [cpPosition]="'bottom'" [cpPositionOffset]="'-75%'">
        <div class="color-box" [style.background]="color||metadata.value"></div>
        <input matInput [value]="color||metadata.value" />
      </div>-->
      <mat-form-field class="property-form-field" *ngIf="metadata.isFieldType('Integer')">
        <mat-label>{{'objects.' + getPropertyName(metadata) | translate}}{{ metadata.isEdited ? '＊' : '' }} </mat-label>
        <input matInput [formControl]="integerField" [value]="metadata.value" (change)="onChangeAtInteger()">
        <mat-error align="start" *ngIf="isIntegerRequiredError() || integerField.hasError('required')">
          <font>{{'objects.errormessage_' + errorMessage.REQUIRED| translate}}</font>
        </mat-error>
        <mat-error align="start" *ngIf="integerField.hasError('pattern') && !integerField.hasError('required')">
          <font>{{'objects.errormessage_' + errorMessage.PATTERN| translate}}</font>
        </mat-error>
      </mat-form-field>
      <mat-form-field class="property-form-field" *ngIf="metadata.isFieldType('TextArea')">
        <mat-label>{{'objects.' + getPropertyName(metadata) | translate}}{{ metadata.isEdited ? '＊' : '' }} </mat-label>
        <textarea matInput type="text" cdkTextareaAutosize [formControl]="textAreaField" [value]="metadata.value"
          (change)="onChangeAtTextArea()"></textarea>
        <mat-error align="start" *ngIf="textAreaField.hasError('required')">
          <font>{{'objects.errormessage_' + errorMessage.REQUIRED| translate}}</font>
        </mat-error>
      </mat-form-field>
      <mat-form-field class="property-form-field" *ngIf="metadata.isFieldType('JSON')">
        <mat-label>{{'objects.' + getPropertyName(metadata) | translate}}{{ metadata.isEdited ? '＊' : '' }} </mat-label>
        <textarea matInput type="text" cdkTextareaAutosize [formControl]="jsonField" [value]="metadata.value"
          (change)="onChangeAtJSON($event)"></textarea>
        <mat-error align="start" *ngIf="jsonField.hasError('required')">
          <font>{{'objects.errormessage_' + errorMessage.REQUIRED| translate}}</font>
        </mat-error>
        <mat-error align="start" *ngIf="jsonField.hasError('syntax')">
          <font>{{'objects.errormessage_' + errorMessage.JSON| translate}}</font>
        </mat-error>
      </mat-form-field>
      <div *ngIf="metadata.isFieldType('Multi')" fxLayout="column">
        <mat-label>{{'objects.' + getPropertyName(metadata) | translate}}{{ metadata.isEdited ? '＊' : '' }} </mat-label>
        <button mat-button color="primary" (click)="addObject()" [disabled]="!isMultiEdit">
          <mat-icon aria-label="">add_box</mat-icon>
        </button>
        <div class="option-message" *ngIf="isOptionsError">{{'propertypreviewEditor.required' | translate}}</div>
      </div>
      <div *ngIf="metadata.isFieldType('List')" fxLayout="row" fxLayoutAlign="end">
        <mat-label>{{'objects.' + getPropertyName(metadata) | translate}}{{ metadata.isEdited ? '＊' : '' }} </mat-label>
        <button mat-button color="primary" (click)="addListItem(metadata)">
          <mat-icon aria-label="">add_box</mat-icon>
        </button>
      </div>
      <div *ngIf="metadata.isFieldType('PriorityItems')" fxLayout="row" fxLayoutAlign="end">
        <mat-label>{{'objects.' + getPropertyName(metadata) | translate}}{{ metadata.isEdited ? '＊' : '' }} </mat-label>
        <button mat-button color="primary" (click)="addPriorityItem()">
          <mat-icon aria-label="">add_box</mat-icon>
        </button>
      </div>
      <div *ngIf="metadata.isFieldType('DropDownOptionItems')" fxLayout="row" fxLayoutAlign="end">
        <mat-label>{{'objects.' + getPropertyName(metadata) | translate}}{{ metadata.isEdited ? '＊' : '' }} </mat-label>
        <button mat-button color="primary" (click)="addDropDownOptionItem()">
          <mat-icon aria-label="">add_box</mat-icon>
        </button>
      </div>
      <!-- Add a branch for a problem that ItemDaataSource cannot be displayed. -->
      <mat-form-field class="property-form-field" *ngIf="metadata.isFieldType('Select') && metadata.name !== 'itemDataSource'">
        <mat-label>{{'objects.' + getPropertyName(metadata) | translate}}{{ metadata.isEdited ? '＊' : '' }} </mat-label>
        <mat-select [formControl]="selectField" [value]="metadata.value" (selectionChange)="onChangeAtSelect()">
          <mat-option *ngIf="!metadata.isRequired" [value]="null" [matTooltip]="'propertypreviewEditor.none' | translate">-{{'propertypreviewEditor.none' | translate}}-</mat-option>

          <mat-option *ngFor="let option of metadata.selectItems" [value]="option.value"
            [matTooltip]="option.noTranslate ? option.label : option.label.split('.')[0] === 'CSV' ? option.label : ('objects.' + option.label | translate)"> {{ option.noTranslate ? option.label : option.label.split('.')[0] === 'CSV' ? option.label : ('objects.' + option.label | translate) }}</mat-option>
        </mat-select>
        <mat-error align="start" *ngIf="isSelectRequiredError() || selectField.hasError('required')">
          <font>{{'objects.errormessage_' + errorMessage.REQUIRED| translate}}</font>
        </mat-error>
      </mat-form-field>
      <mat-form-field class="property-form-field" *ngIf="metadata.isFieldType('Select') && metadata.name === 'itemDataSource'">
        <div> {{ metadata.isEdited ? '＊' : '' }}{{'objects.' + getPropertyName(metadata) | translate}} </div>
        <mat-select [formControl]="selectField" [value]="metadata.value" (selectionChange)="onChangeAtSelect()">
          <mat-option *ngIf="!metadata.isRequired" [value]="null">-{{'propertypreviewEditor.none' | translate}}-</mat-option>
          <!-- select uploaded images -->
          <mat-option *ngFor="let option of metadata.selectItems" [value]="option.value"> {{ option.noTranslate ? option.label : option.label.split('.')[0] === 'CSV' ? option.label : ('objects.' + option.label | translate) }}</mat-option>
        </mat-select>
        <mat-error align="start" *ngIf="isSelectRequiredError() || selectField?.hasError('required')">
          <font>{{'objects.errormessage_' + errorMessage.REQUIRED| translate}}</font>
        </mat-error>
      </mat-form-field>
      <ng-container *ngIf="metadata.isFieldType('CheckBox')">
        <mat-checkbox [checked]="metadata.value" (change)="onChangeAtCheckBox($event)"></mat-checkbox>
        <mat-label>{{'objects.' + getPropertyName(metadata) | translate}}{{ metadata.isEdited ? '＊' : '' }} </mat-label>
      </ng-container>
    </td>
  </ng-container>
  <!-- Table Row -->
  <tr mat-row *matRowDef="let row; columns: propertyTableColumns;"></tr>
</table>
<ng-container *ngIf="isCommon && (metadata.name!=='columnList' && metadata.name!=='rowList')">
  <ng-container *ngIf="metadata.isFieldType('ReadOnly')">
    <mat-label>{{'objects.' + getPropertyName(metadata) | translate}}{{ metadata.isEdited ? '＊' : '' }} </mat-label>
    {{'objects.' + metadata.value | translate}}
  </ng-container>
  <mat-form-field class="property-form-field" *ngIf="metadata.isFieldType('Text')">
    <mat-label>{{'objects.' + getPropertyName(metadata) | translate}}{{ metadata.isEdited ? '＊' : '' }} </mat-label>
    <input matInput type="text" [formControl]="textField" [value]="metadata.value" (change)="onChangeAtText()">
    <mat-error align="start" *ngIf="isRequiredError() || textField.hasError('required')">
      <font>{{'objects.errormessage_' + errorMessage.REQUIRED| translate}}</font>
    </mat-error>
  </mat-form-field>
  <mat-form-field class="property-form-field" *ngIf="metadata.isFieldType('Number')">
    <mat-label>{{'objects.' + getPropertyName(metadata) | translate}}{{ metadata.isEdited ? '＊' : '' }} </mat-label>
    <input matInput [formControl]="numberField" type="number" [value]="metadata.value" (change)="onChangeAtNumber()">
    <mat-error align="start" *ngIf="numberField.hasError('required')">
      <font>{{'objects.errormessage_' + errorMessage.REQUIRED| translate}}</font>
    </mat-error>
    <mat-error align="start" *ngIf="numberField.hasError('pattern') && !numberField.hasError('required')">
      <font>{{'objects.errormessage_' + errorMessage.PATTERN| translate}}</font>
    </mat-error>
  </mat-form-field>
  <mat-form-field class="property-form-field" *ngIf="metadata.isFieldType('Integer')">
    <mat-label>{{'objects.' + getPropertyName(metadata) | translate}}{{ metadata.isEdited ? '＊' : '' }} </mat-label>
    <input matInput [formControl]="integerField" [value]="metadata.value" (change)="onChangeAtInteger()">
    <mat-error align="start" *ngIf="isIntegerRequiredError() || integerField.hasError('required')">
      <font>{{'objects.errormessage_' + errorMessage.REQUIRED| translate}}</font>
    </mat-error>
    <mat-error align="start" *ngIf="integerField.hasError('pattern') && !integerField.hasError('required')">
      <font>{{'objects.errormessage_' + errorMessage.PATTERN| translate}}</font>
    </mat-error>
  </mat-form-field>
  <mat-form-field class="property-form-field" *ngIf="metadata.isFieldType('TextArea')">
    <mat-label>{{'objects.' + getPropertyName(metadata) | translate}}{{ metadata.isEdited ? '＊' : '' }} </mat-label>
    <textarea matInput type="text" cdkTextareaAutosize [formControl]="textAreaField" [value]="metadata.value"
      (change)="onChangeAtTextArea()"></textarea>
    <mat-error align="start" *ngIf="textAreaField.hasError('required')">
      <font>{{'objects.errormessage_' + errorMessage.REQUIRED| translate}}</font>
    </mat-error>
  </mat-form-field>
  <mat-form-field class="property-form-field" *ngIf="metadata.isFieldType('JSON')">
    <mat-label>{{'objects.' + getPropertyName(metadata) | translate}}{{ metadata.isEdited ? '＊' : '' }} </mat-label>
    <textarea matInput type="text" cdkTextareaAutosize [formControl]="jsonField" [value]="metadata.value"
      (change)="onChangeAtJSON($event)"></textarea>
    <mat-error align="start" *ngIf="jsonField.hasError('required')">
      <font>{{'objects.errormessage_' + errorMessage.REQUIRED| translate}}</font>
    </mat-error>
    <mat-error align="start" *ngIf="jsonField.hasError('syntax')">
      <font>{{'objects.errormessage_' + errorMessage.JSON| translate}}</font>
    </mat-error>
  </mat-form-field>
  <div *ngIf="metadata.isFieldType('Multi')" fxLayout="row" fxLayoutAlign="end end">
    <mat-label>{{'objects.' + getPropertyName(metadata) | translate}}{{ metadata.isEdited ? '＊' : '' }} </mat-label>
    <button mat-button color="primary" (click)="addObject()" [disabled]="!isMultiEdit">
      <mat-icon aria-label="">add_box</mat-icon>
    </button>
  </div>
  <div *ngIf="metadata.isFieldType('List')" fxLayout="row" fxLayoutAlign="end end">
    <mat-label>{{'objects.' + getPropertyName(metadata) | translate}}{{ metadata.isEdited ? '＊' : '' }} </mat-label>
    <button mat-button color="primary" (click)="addListItem()">
      <mat-icon aria-label="">add_box</mat-icon>
    </button>
  </div>
  <mat-form-field class="property-form-field" *ngIf="metadata.isFieldType('Select')">
    <mat-label>{{'objects.' + getPropertyName(metadata) | translate}}{{ metadata.isEdited ? '＊' : '' }} </mat-label>
    <mat-select [formControl]="selectField" [value]="metadata.value" (selectionChange)="onChangeAtSelect()">
      <mat-option *ngIf="!metadata.isRequired" [value]="null">-{{'propertypreviewEditor.none' | translate}}-</mat-option>
      <mat-option *ngFor="let option of metadata.selectItems" [value]="option.value">{{'objects.' + option.label | translate}}</mat-option>
    </mat-select>
    <mat-error align="start" *ngIf="selectField.hasError('required')">
      <font>{{'objects.errormessage_' + errorMessage.REQUIRED| translate}}</font>
    </mat-error>
  </mat-form-field>
  <ng-container *ngIf="metadata.isFieldType('CheckBox')">
    <mat-checkbox [checked]="metadata.value" (change)="onChangeAtCheckBox($event)"></mat-checkbox>
  </ng-container>
</ng-container>

<div class="p-3" *ngIf="metadata.isFieldType('Multi') && multiField && multiField.length > 0 && isMultiEdit">
  <mat-table #dragDropTable [dataSource]="optionDataSource" cdkDropList [cdkDropListData]="optionDataSource" (cdkDropListDropped)="dropTable($event)">
    <ng-container matColumnDef="label">
      <mat-header-cell *matHeaderCellDef> {{'propertypreviewEditor.label' | translate}} </mat-header-cell>
      <mat-cell *matCellDef="let option; let i = index;">
        <div>
          <mat-form-field class="option-input property-form-field" floatLabel="never" fxFlex="grow">
            <mat-label>{{'propertypreviewEditor.label' | translate}}</mat-label>
            <input matInput maxlength="{{labelMaxLength}}" [value]="option.label" [(ngModel)]="multiField[i].label"
              (change)="onChangeAtMulti()">
            <mat-error align="start" *ngIf="option.label?.length === 0 || option.label?.length === null">
              <font>{{'propertypreviewEditor.required' | translate}}</font>
            </mat-error>
          </mat-form-field>
        </div>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="value">
      <mat-header-cell class="header-align-left" *matHeaderCellDef> {{'propertypreviewEditor.value' | translate}} </mat-header-cell>
      <mat-cell class="align-left" *matCellDef="let option; let i = index;">
        <div>
          <mat-form-field class="option-input property-form-field" floatLabel="never" fxFlex="grow">
            <input matInput maxlength="{{maxLengthValue ? maxLengthValue : 0}}" placeholder="value" [value]="option.value"
              [(ngModel)]="multiField[i].value" (change)="onChangeAtMulti()">
            <mat-error align="start" *ngIf="option.value?.length > maxLengthValue">
              <font>{{'propertypreviewEditor.overLength' | translate}}</font>
            </mat-error>
            <mat-error align="start" *ngIf="option.value?.length === 0 || option.value?.length === null">
              <font>{{'propertypreviewEditor.required' | translate}}</font>
            </mat-error>
          </mat-form-field>
        </div>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="position">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let option; let i = index;" class="delete-padding-left">
        <div class="sort-icon">
          <mat-icon color="primary" class="table-column-property-panel-draggable" cdkDragHandle>
            drag_indicator
          </mat-icon>
        </div>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="delete">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let option; let i = index;" class="delete-padding-right">
        <div fxLayout="row" fxLayoutAlign="end end" class="align-end">
          <button mat-button color="warn" (click)="deleteOption(i, option.label)">
            <mat-icon aria-label="">delete</mat-icon>
          </button>
        </div>
      </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="['position','label','value','delete']; sticky: true"></mat-header-row>
    <mat-row *matRowDef="let row; columns: ['position','label','value','delete'];" cdkDrag [cdkDragData]="row"></mat-row>
  </mat-table>
</div>

<table *ngIf="metadata.isFieldType('List') && metadata.value" class="mat-table" cdkDropListGroup>
  <div class="property-box" cdkDropList [cdkDropListData]="listItem" (cdkDropListDropped)="listTable($event)">
    <div *ngFor="let item of listItem; index as i">
      <div class="d-flex px-2" cdkDrag >
        <div class="drag-div">
          <mat-icon color="primary" class="table-column-property-panel-draggable" cdkDragHandle>
            drag_indicator
          </mat-icon>
        </div>
        <div class="d-flex flex-column">
          <div>
            <mat-form-field class="width-50 pr-2" fxFlex="grow" [cdkDragDisabled]="item.disabled">
              <mat-label class="font-minimum">{{'propertypreviewEditor.label' | translate}}</mat-label>
              <input matInput placeholder="label" [value]="item.label" [(ngModel)]="item.label" (change)="onChangeAtList()">
            </mat-form-field>
            <mat-form-field class="width-50 pr-2" fxFlex="grow" [cdkDragDisabled]="item.disabled">
              <mat-label class="font-minimum">{{'propertypreviewEditor.width' | translate}}</mat-label>
              <input matInput type="number" min="0" max="100"
                [value]="item.widthRatio" [(ngModel)]="item.widthRatio" (change)="onChangeAtList()">
              <span matSuffix>%</span>
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="width-50 pr-2" fxFlex="grow" [cdkDragDisabled]="item.disabled">
              <mat-label class="font-minimum">{{'propertypreviewEditor.type' | translate}}</mat-label>
              <mat-select placeholder="Type" [value]="item.type" [(ngModel)]="item.type" (selectionChange)="item.dataField=''; onChangeAtList();">
                <mat-option [value]="'Dynamic'">{{'propertypreviewEditor.dynamic' | translate}}</mat-option>
                <mat-option [value]="'Editable'">{{'propertypreviewEditor.editable' | translate}}</mat-option>
                <mat-option [value]="'Dynamic-Editable'">{{'propertypreviewEditor.dynamicEditable' | translate}}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="width-50 pr-2" fxFlex="grow" *ngIf="item.type==='Dynamic'" [cdkDragDisabled]="item.disabled">
              <mat-label class="font-minimum">{{'propertypreviewEditor.dataField' | translate}}</mat-label>
              <mat-select placeholder="Data field Mapping" [value]="item.dataField" [(ngModel)]="item.dataField"
                [disabled]="!item.type || item.type==='Editable'" (selectionChange)="onChangeAtList()">
                <mat-option *ngFor="let option of listDataFieldsForMapping" [value]="option.value">{{'objects.' + option.label | translate}}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="width-50 pr-2" fxFlex="grow" *ngIf="item.type==='Editable'" [cdkDragDisabled]="item.disabled">
              <mat-label class="font-minimum">{{'propertypreviewEditor.inputType' | translate}}</mat-label>
              <mat-select placeholder="Input Type" [value]="item.inputType" [(ngModel)]="item.inputType" (selectionChange)="onChangeAtList()">
                <mat-option [value]="'checkbox'">{{'propertypreviewEditor.checkbox' | translate}}</mat-option>
                <mat-option [value]="'text'">{{'propertypreviewEditor.singlelineText' | translate}}</mat-option>
                <mat-option [value]="'select'">{{'propertypreviewEditor.selectBox' | translate}}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field class="width-50 pr-2" fxFlex="grow" *ngIf="item.type==='Dynamic-Editable'" [cdkDragDisabled]="item.disabled">
              <mat-label class="font-minimum">{{'propertypreviewEditor.dataField' | translate}}</mat-label>
              <mat-select [value]="item.dataField" [(ngModel)]="item.dataField" (selectionChange)="onChangeAtList()">      
                <mat-option *ngFor="let option of metadata.selectItems" [value]="option.value"
                  [matTooltip]="option.noTranslate ? option.label : option.label.split('.')[0] === 'CSV' ? option.label : ('objects.' + option.label | translate)"> {{ option.noTranslate ? option.label : option.label.split('.')[0] === 'CSV' ? option.label : ('objects.' + option.label | translate) }}</mat-option>
                </mat-select>
            </mat-form-field>
            <div class="d-flex" *ngIf="item.inputType==='select'" [cdkDragDisabled]="item.disabled">
              <mat-form-field class="width-80 p-3">
                <mat-label class="font-minimum">{{'propertypreviewEditor.addOptions' | translate}}</mat-label>
                <mat-chip-grid #optionList>
                  <mat-chip-row *ngFor="let option of item.optionList; index as i" (removed)="removeOption(item, i)">
                    {{option}}
                    <mat-icon matChipRemove>cancel</mat-icon>
                  </mat-chip-row>
                  <input [matChipInputFor]="optionList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                    [matChipInputAddOnBlur]="true" (matChipInputTokenEnd)="addOption(item, $event)">
                </mat-chip-grid>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="delete-div">
          <button class="delete-button" mat-button color="warn" (click)="deleteLabel(i, item.label)">
            <mat-icon aria-label="">delete</mat-icon>
          </button>
        </div>
      </div>
      <mat-divider></mat-divider>
    </div>
  </div>
</table>

<div *ngIf="metadata.isFieldType('TableHeader') && metadata.value && metadata.name === 'columnList'">
  <mat-form-field class="p-3">
    <mat-label>{{'propertypreviewEditor.addnewColumn' | translate}}</mat-label>
    <mat-chip-grid #columnList>
      <mat-chip-row *ngFor="let header of tableColumnHeader; index as i" (removed)="removeTableHeader(metadata.name, i)">
        {{header.label}}
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip-row>
      <input [matChipInputFor]="columnList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        [matChipInputAddOnBlur]="true" (matChipInputTokenEnd)="addTableHeader(metadata.name, $event)">
    </mat-chip-grid>
  </mat-form-field>

  <div class="property-box" *ngFor="let header of tableColumnHeader; index as i">
    <div class="d-flex px-12">
      <mat-form-field class="form-field px-4">
        <mat-label class="font-minimum">{{'propertypreviewEditor.columnLabel' | translate}}</mat-label>
        <input matInput placeholder="Header label" [value]="header.label" [(ngModel)]="header.label" (change)="onChangeAtTableHeader()" />
      </mat-form-field>
      <mat-form-field class="form-field px-4">
        <mat-label class="font-minimum">{{'propertypreviewEditor.columnWidth' | translate}}</mat-label>
        <input matInput placeholder="Column Width" [value]="header.width" [(ngModel)]="header.width" (change)="onChangeAtTableHeader()" />
      </mat-form-field>
    </div>
    <div class="d-flex px-12">
      <mat-form-field class="form-field px-4">
        <mat-label class="font-minimum">{{'propertypreviewEditor.inputType' | translate}}</mat-label>
        <mat-select [placeholder]="'propertypreviewEditor.inputType' | translate" [value]="header.inputType" [(ngModel)]="header.inputType"
          (selectionChange)="onChangeAtTableHeader()">
          <mat-option [value]="'radio'">{{'propertypreviewEditor.singleSelection' | translate}}</mat-option>
          <mat-option [value]="'checkbox'">{{'propertypreviewEditor.checkbox' | translate}}</mat-option>
          <mat-option [value]="'text'">{{'propertypreviewEditor.singlelineText' | translate}}</mat-option>
          <mat-option [value]="'textarea'">{{'propertypreviewEditor.multilineText' | translate}}</mat-option>
          <mat-option [value]="'select'">{{'propertypreviewEditor.selectBox' | translate}}</mat-option>
          <mat-option [value]="'image'">{{'propertypreviewEditor.image' | translate}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="form-field px-4">
        <mat-label class="font-minimum">{{'propertypreviewEditor.textOrientation' | translate}}</mat-label>
        <mat-select [placeholder]="'propertypreviewEditor.textOrientation' | translate" [value]="header.textOrientation" [(ngModel)]="header.textOrientation"
          (selectionChange)="onChangeAtTableHeader()">
          <mat-option [value]="'horizontal'">{{'propertypreviewEditor.horizontal' | translate}}</mat-option>
          <mat-option [value]="'vertical'">{{'propertypreviewEditor.vertical' | translate}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="d-flex px-12">
      <mat-form-field class="form-field px-4">
        <mat-label class="font-minimum">{{'propertypreviewEditor.textAlignment' | translate}}</mat-label>
        <mat-select [placeholder]="'propertypreviewEditor.textAlignment' | translate" [value]="header.textAlignment" [(ngModel)]="header.textAlignment"
          (selectionChange)="onChangeAtTableHeader()">
          <mat-option [value]="'Left'">{{'propertypreviewEditor.left' | translate}}</mat-option>
          <mat-option [value]="'center'">{{'propertypreviewEditor.center' | translate}}</mat-option>
          <mat-option [value]="'Right'">{{'propertypreviewEditor.right' | translate}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="form-field px-4">
        <mat-label class="font-minimum">{{'propertypreviewEditor.tagging' | translate}}</mat-label>
        <mat-select [placeholder]="'propertypreviewEditor.tagging' | translate" [value]="header.tagging" [(ngModel)]="header.tagging" (selectionChange)="onChangeAtTableHeader()">
          <mat-option [value]="''">{{'propertypreviewEditor.None' | translate}}</mat-option>
          <mat-option [value]="'StatusItem'">{{'propertypreviewEditor.statusItem' | translate}}</mat-option>
          <mat-option [value]="'PriorityItem'">{{'propertypreviewEditor.priorityItem' | translate}}</mat-option>
          <mat-option [value]="'Comments'">{{'propertypreviewEditor.comments' | translate}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="d-flex px-12">
      <mat-form-field class="form-field px-4">
        <mat-label class="font-minimum" *ngIf="designService.selectLabel !== ''">{{'objects.'+ designService.selectLabel | translate}}</mat-label>
        <mat-select [placeholder]="'propertypreviewEditor.event' | translate" [value]="header.dataField" [(ngModel)]="header.dataField"
          (selectionChange)="onChangeAtTableHeader()">
          <mat-option *ngFor="let selectProperty of designService.selectProperties; index as i" [value]="selectProperty.label">
            {{ 'objects.' + selectProperty.value | translate }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="d-flex px-4">
      <div class="px-3">
        <input class="mr-1" type="checkbox" [(ngModel)]="header.needsPriority" [checked]="header.needsPriority"
          (change)="onChangeAtTableHeader()" />
        <span> {{'propertypreviewEditor.needspriorityCode' | translate}} </span>
      </div>
    </div>
  </div>
</div>

<div class="p-3" *ngIf="metadata.isFieldType('PriorityItems')">
  <mat-table #priorityItemspTable [dataSource]="priorityItemsDataSource" cdkDropList [cdkDropListData]="priorityItemsDataSource" (cdkDropListDropped)="priorityDropTable($event)">
    <ng-container matColumnDef="code">
      <mat-header-cell *matHeaderCellDef> {{'propertypreviewEditor.code' | translate}} </mat-header-cell>
      <mat-cell *matCellDef="let priorityItem; let i = index;">
          <mat-form-field class="option-input property-form-field" floatLabel="never" fxFlex="grow">
            <mat-label>{{'propertypreviewEditor.code' | translate}}</mat-label>
            <input matInput [value]="priorityItem.code" [(ngModel)]="priorityItem.code"
            (change)="onChangeAtPriorityItems()">
          </mat-form-field>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="label">
      <mat-header-cell class="header-align-left" *matHeaderCellDef> {{'propertypreviewEditor.Label' | translate}} </mat-header-cell>
      <mat-cell class="align-left" *matCellDef="let priorityItem; let i = index;">
          <mat-form-field class="option-input property-form-field" floatLabel="never" fxFlex="grow">
            <mat-label>{{'propertypreviewEditor.Label' | translate}}</mat-label>
            <input matInput [value]="priorityItem.label" [(ngModel)]="priorityItem.label"
            (change)="onChangeAtPriorityItems()">
          </mat-form-field>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="position">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let priorityItem; let i = index;" class="delete-padding-left">
        <div class="sort-icon">
          <mat-icon color="primary" class="table-column-property-panel-draggable" cdkDragHandle>
            drag_indicator
          </mat-icon>
        </div>
      </mat-cell>
    </ng-container>
      <ng-container matColumnDef="delete">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let priorityItem; let i = index;" class="delete-padding-right">
          <div fxLayout="row" fxLayoutAlign="end end" class="align-end">
            <button mat-button class="mat-cell-delete" color="warn" (click)="deletePriority(i, priorityItem.code)">
              <mat-icon aria-label="">delete</mat-icon>
            </button>
          </div>
        </mat-cell>
      </ng-container>
    <mat-header-row *matHeaderRowDef="['position','code','label','delete']; sticky: true"></mat-header-row>
    <mat-row *matRowDef="let row; columns: ['position','code','label','delete'];" cdkDrag [cdkDragData]="row"></mat-row>
  </mat-table>
</div>

<div class="p-3" *ngIf="metadata.isFieldType('DropDownOptionItems')">
  <table class="mat-table">
    <tr *ngFor="let dropDownOptionItem of dropDownOptionItems; index as i">
      <td width="2%"></td>
      <td width="90%">
        <mat-form-field class="option-input pr-3" fxFlex="grow">
          <mat-label>{{'propertypreviewEditor.Label' | translate}}</mat-label>
          <input matInput [placeholder]="'propertypreviewEditor.label' | translate" [value]="dropDownOptionItem.label" [(ngModel)]="dropDownOptionItem.label"
            (change)="onChangeAtDropDownOptionItems()">
        </mat-form-field>
      </td>
      <td width="8%">
        <mat-icon aria-label="delete item" color="warn" (click)="deleteDropDownOption(i, dropDownOptionItems)">delete</mat-icon>
      </td>
    </tr>
  </table>
</div>

<div *ngIf="metadata.isFieldType('TableHeader') && metadata.value && metadata.name === 'rowList'">
  <mat-form-field class="p-3">
    <mat-label>{{'propertypreviewEditor.addnewRow' | translate}}</mat-label>
    <mat-chip-grid #rowList>
      <mat-chip-row *ngFor="let header of tableRowHeader; index as i" (removed)="removeTableHeader(metadata.name, i)">
        <!-- table row -->
        {{ header.label }}
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip-row>
    </mat-chip-grid>
    <input [matChipInputFor]="rowList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [maxlength]="maxVeLabelLength"
        [matChipInputAddOnBlur]="true" (matChipInputTokenEnd)="addTableHeader(metadata.name, $event)">
  </mat-form-field>
  <div class="property-box" *ngFor="let header of tableRowHeader; index as i">
    <div class="d-flex px-12">
      <mat-form-field class="form-field px-4">
        <mat-label class="font-minimum">{{'propertypreviewEditor.rowheaderLabel' | translate}}</mat-label>
        <input class="font-minimum" matInput [placeholder]="'propertypreviewEditor.headerlabel' | translate" [maxlength]="maxVeLabelLength"
          [value]="header.label" [(ngModel)]="header.label" (change)="onChangeAtTableHeader()">
      </mat-form-field>
      <mat-form-field class="form-field px-4">
        <mat-label class="font-minimum">{{'propertypreviewEditor.textAlignment' | translate}}</mat-label>
        <mat-select [placeholder]="'propertypreviewEditor.textAlignment' | translate" [value]="header.textAlignment" [(ngModel)]="header.textAlignment"
          (selectionChange)="onChangeAtTableHeader()">
          <mat-option [value]="'Left'">{{'propertypreviewEditor.left' | translate}}</mat-option>
          <mat-option [value]="'center'">{{'propertypreviewEditor.center' | translate}}</mat-option>
          <mat-option [value]="'Right'">{{'propertypreviewEditor.right' | translate}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="d-flex px-12">
      <mat-form-field class="form-field px-4">
        <mat-label class="font-minimum">{{'propertypreviewEditor.tagging' | translate}}</mat-label>
        <mat-select [placeholder]="'propertypreviewEditor.tagging' | translate" [value]="header.tagging" [(ngModel)]="header.tagging" (selectionChange)="onChangeAtTableHeader()">
          <mat-option [value]="''">{{'propertypreviewEditor.None' | translate}}</mat-option>
          <mat-option [value]="'VisualEventTypeItem'">{{'propertypreviewEditor.visualeventtypeItem' | translate}}</mat-option>
        </mat-select>
      </mat-form-field>    
    </div>
    <div class="d-flex px-4">
      <div class="px-3">
        <input class="mr-1" type="checkbox" [(ngModel)]="header.requiredField" [checked]="header.requiredField"
        (change)="onChangeAtTableHeader()" />
        <span> {{'propertypreviewEditor.requiredField' | translate}} </span>
      </div>
    </div>
  </div>
</div>

<div *ngIf="metadata.isFieldType('TableColumn')" class="mat-table">
  <div class="table-column-property-section-title-div">
    <label class="table-column-property-section-title-font table-column-property-section-title-label">{{'propertypreviewEditor.columns' | translate}}</label>
    <a mat-button
       class="table-column-property-section-title-font table-column-property-add-button"
       color="primary"
       (click)="addTableColumn(metadata.name)">
      <mat-icon aria-label="">add_box</mat-icon></a>
    <a mat-button
       class="table-column-property-section-title-font"
       (click)="expandAllTableColumns()">{{'propertypreviewEditor.expand' | translate}}</a>
    <a mat-button
       class="table-column-property-section-title-font"
       (click)="collapseAllTableColumns()">{{'propertypreviewEditor.collapse' | translate}}</a>
  </div>
  <mat-accordion #tableColumnAccordion="matAccordion"
                 multi="true"
                 displayMode="flat"
                 cdkDropList
                 (cdkDropListDropped)="moveTableColumn($event)">
    <mat-expansion-panel *ngFor="let column of tableColumns; index as i1"
                         #tableColumnAccordionPanels="matExpansionPanel"
                         [id]="tableColumnPropertyPanelIdPrefix + i1"
                         class="table-column-property-panel"
                         cdkDrag
                         cdkDragLockAxis="y">

      <!-- #region Column property header -->
      <mat-expansion-panel-header>
        <mat-panel-title>
          <ng-template *ngTemplateOutlet="tableColumnPropertyPanelHeaderTemplate"></ng-template>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div *cdkDragPreview>
        <ng-template *ngTemplateOutlet="tableColumnPropertyPanelHeaderTemplate"></ng-template>
      </div>

      <ng-template #tableColumnPropertyPanelHeaderTemplate>
        <div class="table-column-property-panel-header-template">
          <mat-icon color="primary" class="table-column-property-panel-draggable"
                    cdkDragHandle>drag_indicator</mat-icon>
          <span style="padding-left: 5px; white-space: nowrap;">{{column.header}}</span>
        </div>
      </ng-template>
      <!-- #endregion -->

      <div class="d-flex px-4">
        <app-drop-down-list-input style="width: 100%" [value]="column.header"
                                  [displayOptions]="getDisplayOptions('header')"
                                  [width]="100"
                                  (inputValue)="column.header = $event;onChangeAtTableColumn()">
        </app-drop-down-list-input>
      </div>
      <div class="d-flex px-4">
        <div class="width-50 px-3">
          <mat-label>{{'propertypreviewEditor.items' | translate}}</mat-label>
        </div>
        <div class="width-50 px-3" fxLayout="row" fxLayoutAlign="end end">
          <button mat-button color="primary" (click)="addText(i1)" [disabled]="!isMultiEdit">
            <mat-icon aria-label="">add_box</mat-icon>
          </button>
        </div>
      </div>
      <div class="px-12" *ngFor="let textsInfo of column.textsInfo; index as i2">
        <div fxLayout="row" fxLayoutAlign="end end" style="margin-left: 40px;">
          {{"item" + (i2 + 1)}}
          <button mat-button color="warn" (click)="deleteItem(i1, i2)">
            <mat-icon aria-label="">delete</mat-icon>
          </button>
        </div>
        <app-texts-info-input [value]="textsInfo"
                              [displayOptions]="getDisplayOptions()"
                              [typeOptions]="getTypeOptions()"
                              [width]="120"
                              (inputValue)="updateTextComponent(textsInfo, $event)">

        </app-texts-info-input>
      </div>
      <div class="d-flex px-12">
        <mat-form-field class="form-field px-12">
          <mat-label class="font-minimum">{{'propertypreviewEditor.fontSize' | translate}}</mat-label>
          <input type="number" matInput [value]="column.fontSize" [(ngModel)]="column.fontSize" (change)="onChangeAtTableColumn()">
        </mat-form-field>
        <mat-form-field class="form-field px-12">
          <mat-label class="font-minimum">{{'propertypreviewEditor.fontFamily' | translate}}</mat-label>
          <mat-select [placeholder]="'propertypreviewEditor.fontFamily' | translate" [value]="column.fontFamily" [(ngModel)]="column.fontFamily"
                      (selectionChange)="onChangeAtTableColumn()">
            <mat-option [value]="'Times New Roman'">{{'propertypreviewEditor.timesnewRoman' | translate}}</mat-option>
            <mat-option [value]="'sans-serif'">{{'propertypreviewEditor.sansserif' | translate}}</mat-option>
            <mat-option [value]="'serif'">{{'propertypreviewEditor.serif' | translate}}</mat-option>
            <mat-option [value]="'Arial'">{{'propertypreviewEditor.arial' | translate}}</mat-option>
            <mat-option [value]="'Calibri'">{{'propertypreviewEditor.calibri' | translate}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="d-flex px-12">
        <mat-form-field class="form-field px-12">
          <mat-label class="font-minimum">{{'propertypreviewEditor.horizontalAlign' | translate}}</mat-label>
          <mat-select [placeholder]="'propertypreviewEditor.horizontalAlign' | translate" [value]="column.horizontalAlign" [(ngModel)]="column.horizontalAlign"
                      (selectionChange)="onChangeAtTableColumn()">
            <mat-option [value]="'left'">{{'propertypreviewEditor.left' | translate}}</mat-option>
            <mat-option [value]="'center'">{{'propertypreviewEditor.Center' | translate}}</mat-option>
            <mat-option [value]="'right'">{{'propertypreviewEditor.right' | translate}}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="form-field px-12">
          <mat-label class="font-minimum">{{'propertypreviewEditor.verticalAlign' | translate}}</mat-label>
          <mat-select [placeholder]="'propertypreviewEditor.verticalAlign' | translate" [value]="column.verticalAlign" [(ngModel)]="column.verticalAlign"
                      (selectionChange)="onChangeAtTableColumn()">
            <mat-option [value]="'top'">{{'propertypreviewEditor.top' | translate}}</mat-option>
            <mat-option [value]="'middle'">{{'propertypreviewEditor.middle' | translate}}</mat-option>
            <mat-option [value]="'bottom'">{{'propertypreviewEditor.bottom' | translate}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="d-flex px-12">
        <mat-form-field class="form-field px-12">
          <mat-label class="font-minimum">{{'propertypreviewEditor.paddingLeft' | translate}}</mat-label>
          <input type="number" matInput [placeholder]="'propertypreviewEditor.paddingLeft' | translate" [value]="column.paddingLeft" [(ngModel)]="column.paddingLeft"
                (change)="onChangeAtTableColumn()" />
        </mat-form-field>
        <mat-form-field class="form-field px-12">
          <mat-label class="font-minimum">{{'propertypreviewEditor.paddingBottom' | translate}}</mat-label>
          <input type="number" matInput [placeholder]="'propertypreviewEditor.paddingBottom' | translate" [value]="column.paddingBottom" [(ngModel)]="column.paddingBottom"
                (change)="onChangeAtTableColumn()" />
        </mat-form-field>
      </div>
      <div class="d-flex px-12">
        <mat-form-field class="form-field px-12">
          <mat-label class="font-minimum">{{'propertypreviewEditor.paddingRight' | translate}}</mat-label>
          <input type="number" matInput [placeholder]="'propertypreviewEditor.paddingRight' | translate" [value]="column.paddingRight" [(ngModel)]="column.paddingRight"
                (change)="onChangeAtTableColumn()" />
        </mat-form-field>
        <mat-form-field class="form-field px-12">
          <mat-label class="font-minimum">{{'propertypreviewEditor.paddingTop' | translate}}</mat-label>
          <input type="number" matInput [placeholder]="'propertypreviewEditor.paddingTop' | translate" [value]="column.paddingTop" [(ngModel)]="column.paddingTop"
                (change)="onChangeAtTableColumn()" />
        </mat-form-field>
      </div>
      <div class="d-flex px-12">
        <mat-form-field class="form-field px-12">
          <mat-label class="font-minimum">{{'propertypreviewEditor.widthRatio' | translate}}</mat-label>
          <input type="number" matInput [placeholder]="'propertypreviewEditor.widthRatio' | translate" [value]="column.widthRatio" [(ngModel)]="column.widthRatio"
                (change)="onChangeAtTableColumn()" />
        </mat-form-field>
      </div>
      <div class="d-flex px-4">
        <div class="px-3">
          <input class="mr-1" type="checkbox" [(ngModel)]="column.isHeaderVertical" [checked]="column.isHeaderVertical"
                (change)="onChangeAtTableColumn()" />
          <span> {{'propertypreviewEditor.isHeaderVertical' | translate}} </span>
        </div>
      </div>
      <div class="d-flex px-4">
        <div class="px-3">
          <input class="mr-1" type="checkbox" [(ngModel)]="column.isColumnVertical" [checked]="column.isColumnVertical"
                (change)="onChangeAtTableColumn()" />
          <span> {{'propertypreviewEditor.isColumnVertical' | translate}} </span>
        </div>
      </div>
      <div class="d-flex px-4">
        <div class="px-3">
          <input class="mr-1" type="checkbox" [(ngModel)]="column.isCombined" [checked]="column.isCombined"
                (change)="onChangeAtTableColumn()" />
          <span> {{'propertypreviewEditor.isCombined' | translate}} </span>
        </div>
      </div>
      <div class="d-flex px-4">
        <div class="px-3">
          <input class="mr-1" type="checkbox" [(ngModel)]="column.isItemsHorizontal" [checked]="column.isItemsHorizontal"
                (change)="onChangeAtTableColumn()" />
          <span> {{'propertypreviewEditor.isItemsHorizontal' | translate}} </span>
        </div>
      </div>

      <div class="d-flex px-4 table-column-property-delete-button-div">
        <button mat-stroked-button
                color="warn"
                (click)='deleteColumn(metadata.name, i1, column.header)'>
          {{'propertypreviewEditor.delete' | translate}}
        </button>
      </div>
    </mat-expansion-panel>
  </mat-accordion>
</div>
